import {
  AppMenu,
  AppMenuBrand,
  AppMenuDivider,
  AppMenuSection,
} from "@/adapters/inbound/layout";
import { Menu, MenuItemLink } from "react-admin";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import WorkIcon from "@mui/icons-material/Work";
import BusinessIcon from "@mui/icons-material/Business";
import PlaceIcon from "@mui/icons-material/Place";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { useDI } from "@/infrastructure/di/useDI";

export function MyMenu(props: any) {
  const navigate = useNavigate();
  const { logout } = useDI();

  async function handleLogout(event: React.MouseEvent) {
    event.preventDefault();

    await logout.execute();

    navigate("/login", { replace: true });
  }

  return (
    <AppMenu {...props}>

      <AppMenuBrand />

      <AppMenuSection>
        <Menu.DashboardItem
          primaryText="Dashboard"
          leftIcon={<DashboardIcon />}
        />
      </AppMenuSection>

      <AppMenuDivider />

      <AppMenuSection title="Arbeitsbereich">
        <Menu.ResourceItem
          name="jobs"
          primaryText="Aufträge"
          leftIcon={<WorkIcon />}
        />
        <Menu.ResourceItem
          name="constructionSites"
          primaryText="Einsatzorte"
          leftIcon={<HomeRepairServiceIcon />}
        />
      </AppMenuSection>

      <AppMenuDivider />

      <AppMenuSection title="Stammdaten">
        <Menu.ResourceItem
          name="clients"
          primaryText="Kunden"
          leftIcon={<BusinessIcon />}
        />
        <Menu.ResourceItem
          name="persons"
          primaryText="Mitarbeiter"
          leftIcon={<PeopleAltIcon />}
        />
        <Menu.ResourceItem
          name="addresses"
          primaryText="Adressen"
          leftIcon={<PlaceIcon />}
        />
      </AppMenuSection>

      <AppMenuDivider />

      <AppMenuSection title="Einstellungen">
        <MenuItemLink
          to="/dashboard/settings/account/seats"
          primaryText="Sitze & Nutzer"
          leftIcon={<ManageAccountsIcon />}
        />
        <MenuItemLink
          to="/dashboard/settings/account/billing"
          primaryText="Abrechnung"
          leftIcon={<ReceiptLongIcon />}
        />
      </AppMenuSection>

      <AppMenuDivider />

      <AppMenuSection>
        <MenuItemLink
          to="/login"
          primaryText="Abmelden"
          leftIcon={<LogoutIcon />}
          onClick={handleLogout}
        />
      </AppMenuSection>
    </AppMenu>
  );
}
